import React, { PureComponent } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Modal from "../../reusable/Modal/Modal";
import {
	secondaryTextColor,
	titleL,
	fw500,
	fw400,
	titleS,
} from "../../../Global.module.css";
import styles from "./ImageCrop.module.css";

export default class ImageCrop extends PureComponent {
	state = {
		src: this.props.src,
		crop: {
			aspect: this.props.fullSize ? 1.6 / 1 : 0.78 / 1,
		},
	};

	// If you setState the crop in here you should return false.
	onImageLoaded = (image) => {
		this.imageRef = image;
	};

	onCropComplete = (crop) => {
		this.makeClientCrop(crop);
	};

	onCropChange = (crop) => {
		this.setState({ crop });
	};

	async makeClientCrop(crop) {
		if (this.imageRef && crop.width && crop.height) {
			const croppedImageUrl = await this.getCroppedImg(
				this.imageRef,
				crop
			);
			this.setState({ croppedImageUrl });
		}
	}

	getCroppedImg(image, crop) {
		const canvas = document.createElement("canvas");
		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		canvas.width = crop.width;
		canvas.height = crop.height;
		const ctx = canvas.getContext("2d");

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width,
			crop.height
		);

		return new Promise((resolve, reject) => {
			resolve(canvas.toDataURL("image/png", 0.7));
		});
	}

	done = () => {
		this.props.onComplete(this.state.croppedImageUrl || this.state.src);
	};

	handleEnter = (e) => {
		if (
			e.keyCode === 13 ||
			e.key === "Enter" ||
			e.code === "Enter" ||
			e.code === "NumpadEnter"
		) {
			this.done();
		}
	};

	componentDidMount() {
		document.addEventListener("keydown", this.handleEnter);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.handleEnter);
	}

	render() {
		const { crop, src } = this.state;

		return (
			<Modal>
				<div
					className={`${styles.imageCrop} ${secondaryTextColor} ${titleL} ${fw500}`}
				>
					<p>Crop Image</p>
					<p
						className={`${styles.closeBtn} ${secondaryTextColor} ${fw400} ${titleS}`}
						onClick={() => this.props.onComplete()}
					>
						X
					</p>

					{src && (
						<ReactCrop
							className={styles.reactCrop}
							src={src}
							crop={crop}
							ruleOfThirds
							onImageLoaded={this.onImageLoaded}
							onComplete={this.onCropComplete}
							onChange={this.onCropChange}
							crossorigin="anonymous"
						/>
					)}
					<p className={styles.done} onClick={this.done}>
						Done
					</p>
				</div>
			</Modal>
		);
	}
}
